import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const BoldIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 16 16"
    >
      <path
        d="M10.5733 7.64667C12.12 7.58001 13.4067 6.68001 13.4067 4.43334C13.4067 2.18667 11.9 0.67334 9.39333 0.67334H2V15.34H10.0733C12.32 15.34 14 13.4733 14 11.16C14 8.64001 12.0133 7.65334 10.5733 7.65334V7.64667ZM5.32 3.35334H8.61333C9.48667 3.35334 10.0067 4.17334 10.0067 5.01334C10.0067 5.85334 9.48 6.67334 8.61333 6.67334H5.32V3.35334ZM9.13333 12.6467H5.31333V9.28667H9.13333C10.0067 9.28667 10.5533 10.1267 10.5533 10.9667C10.5533 11.8067 10.0067 12.6467 9.13333 12.6467Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

BoldIcon.displayName = 'BoldIcon';
